<template>
  <!-- this has been modified to begin the process of adding autocomplete to allow call from autocomplete to show data-->
  <div class="Container">
    <h2 class="ViewHeading">Errors</h2>

    <div class="tab">
      <button
        v-if="selectedReport != 'AWSErrors'"
        class="reportTabLeft"
        v-on:click="
          selectedReport = 'AWSErrors';
          resetInputs();
        "
      >
        AWS Errors
      </button>
      <button
        v-if="selectedReport == 'AWSErrors'"
        class="reportTabActiveLeft"
        v-on:click="selectedReport = 'AWSErrors'"
      >
        AWS Errors
      </button>
      <button
        v-if="selectedReport != 'DeviceErrors'"
        class="reportTab"
        v-on:click="
          selectedReport = 'DeviceErrors';
          resetInputs();
        "
      >
        Device Errors
      </button>
      <button
        v-if="selectedReport == 'DeviceErrors'"
        class="reportTabActive"
        v-on:click="selectedReport = 'DeviceErrors'"
      >
        Device Errors
      </button>
    </div>

    <div class="tabcontent">
      <b-row class="SelectionRow" v-if="selectedReport == ''">
        <b-col cols="24" md="12">
          <h5 class="TextPlaceholder">Please select an above overview</h5>
        </b-col>
      </b-row>

      <b-row v-if="selectedReport == 'AWSErrors'">
        <b-col cols="24" md="12">
          <h5 class="TextPlaceholder">AWS Errors</h5>
        </b-col>
        <b-col cols="24" md="12">
          <b-col cols="8" md="4">
            <label class="Selector" for=""> From Date : </label>
            <b-form-datepicker type="date" v-model="AWSFromDate" />
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for=""> To Date : </label>
            <b-form-datepicker type="date" v-model="AWSToDate" />
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for=""> Error Code : </label>
            <select v-model="AWSErrorCode">
              <option value="" select disabled>Select Error Code</option>
              <option value="400"> 400 </option>
            </select>
          </b-col>
        </b-col>
        <b-col cols="24" md="12">
          <b-col cols="8" md="4">
            <label class="Selector" for=""> Location : </label>
            <select v-model="AWSLocation">
              <option value="" select disabled>Select Location</option>
              <option
                v-for="(value, id) in this.locationsArray"
                :key="id"
                v-bind:value="{ id: value.location }"
                >{{ value.location }}</option
              >
            </select>
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for="deviceLocationSearch">
              Company :
            </label>
            <select v-model="AWSCompany">
              <option value="" select disabled>Select Company</option>
              <option
                v-for="(value, id) in this.companyArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.name }"
                >{{ value.name }}</option
              >
            </select>
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for="deviceLocationSearch">
              Device ID :
            </label>
            <select v-model="AWSDeviceID">
              <option value="" select disabled>Select Device</option>
              <option
                v-for="(value, id) in this.deviceArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.name }"
                >{{ value.id }}</option
              >
            </select>
          </b-col>
        </b-col>
        <b-col cols="24">
          <b-button id="button" class="button" v-on:click="AWSErrorFilter()"
            >Filter Errors</b-button
          >
          <b-button class="button" v-on:click="AWSErrorResetFilter()"
            >Clear Filters</b-button
          >
        </b-col>
        <b-col cols="24" md="12">
          <b-pagination
            v-model="AWScurrentPage"
            :total-rows="AWSrows"
            :per-page="AWSperPage"
            aria-controls="AWSErrorsTable"
          ></b-pagination>
          <b-table
            stacked="md"
            id="AWSErrorsTable"
            hover
            striped
            :items="this.AWSErrorsList"
            :fields="fields"
            show-empty
            empty-text="Please select different filters"
            head-variant="dark"
            table-variant="light"
            :per-page="perPage"
            :current-page="AWScurrentPage"
            small
            bordered
          >
          </b-table>
        </b-col>
      </b-row>
      <b-row v-if="selectedReport == 'DeviceErrors'">
        <b-col cols="24" md="12">
          <h5 class="TextPlaceholder">Device Errors</h5>
        </b-col>
        <b-col cols="24" md="12">
          <b-col cols="8" md="4">
            <label class="Selector" for=""> From Date : </label>
            <b-form-datepicker type="date" v-model="DeviceFromDate" />
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for=""> To Date : </label>
            <b-form-datepicker type="date" v-model="DeviceToDate" />
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for=""> Error Code : </label>
            <select v-model="DeviceErrorCode">
              <option value="" select disabled>Select Error Code</option>
              <option
                v-for="(value, id) in this.DeviceErrorCodes"
                :key="id"
                v-bind:value="{ id: value.id }"
                >{{ value.id }}</option
              >
            </select>
          </b-col>
        </b-col>
        <b-col cols="24" md="12">
          <b-col cols="8" md="4">
            <label class="Selector" for=""> Location : </label>
            <select v-model="DeviceLocation">
              <option value="" select disabled>Select Location </option>
              <option
                v-for="(value, id) in this.locationsArray"
                :key="id"
                v-bind:value="{ id: value.location }"
                >{{ value.location }}</option
              >
            </select>
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for="deviceLocationSearch">
              Company :
            </label>
            <select v-model="DeviceCompany">
              <option value="" select disabled>Select Company</option>
              <option
                v-for="(value, id) in this.companyArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.name }"
                >{{ value.name }}</option
              >
            </select>
          </b-col>
          <b-col cols="8" md="4">
            <label class="Selector" for="deviceLocationSearch">
              Device ID :
            </label>
            <select v-model="DeviceID">
              <option value="" select disabled>Select Device</option>
              <option
                v-for="(value, id) in this.deviceArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.name }"
                >{{ value.id }}</option
              >
            </select>
          </b-col>
        </b-col>
        <b-col cols="24">
          <b-button id="button" class="button" v-on:click="DeviceErrorFilter()"
            >Filter Errors</b-button
          >
          <b-button class="button" v-on:click="DeviceErrorResetFilter()"
            >Clear Filters</b-button
          >
        </b-col>
        <b-col cols="24" md="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="DeviceErrorsTable"
          ></b-pagination>
          <b-table
            stacked="md"
            id="DeviceErrorsTable"
            hover
            striped
            :items="this.items"
            :fields="fields"
            show-empty
            empty-text="Please select different filters"
            head-variant="dark"
            table-variant="light"
            :per-page="perPage"
            :current-page="currentPage"
            small
            bordered
          >
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    rows() {
      return this.items.length;
    },

    AWSRows() {
      return this.AWSErrorsList.length;
    },
  },
  data() {
    return {
      info: null,
      response: null,
      table_name: "",
      Values: null,
      done: false,
      location: "",
      ArrTest: [],
      items: [],
      fields: [],
      UserHeaders: null,
      perPage: 15,
      AWSperPage: 15,
      currentPage: 1,
      AWScurrentPage: 1,
      locations: [],
      filteredlocations: [],
      modal: false,
      UnitAction: "",
      AlarmtobeActioned: "",
      AlarmNote: "",
      checkedactions: [],
      selected: "",
      selectedEstates: "",
      selectedEscalation: "",

      ServiceAssign: "",
      ServiceType: "",
      ContactArray: [],
      Note: "",
      AlarmCategory: "",
      UpdateStatus: "",
      messageEstates: "",
      messageEscalate: "",
      Company: this.$Company,
      locationsArray: [],
      locationslist: [],
      locationSearch: "",
      SearchCategory: "",
      SearchAlert: "",
      FilterType: "",
      UserURN: this.$UserURN,
      UserLocation: this.$Location,
      Devices: "",
      ArrDevice: [],
      deviceSearch: "",
      selectedReport: "",
      AWSErrors: "",
      AWSErrorsList: "",
      AWSrows: "",

      AWSFromDate: "",
      AWSToDate: "",
      DeviceFromDate: "",
      DeviceToDate: "",
      DeviceErrorCodesList: "",
      DeviceErrorCodes: [],
      companyArray: [],
      companyList: "",
      DeviceLocation: "",
      DeviceErrorCode: "",
      DeviceCompany: "",
      deviceList: "",
      deviceArray: [],
      DeviceID: "",
      DeviceFilterType: [],
      AWSFilterType: [],
      AWSDeviceID: "",
      AWSCompany: "",
      AWSLocation: "",
      AWSErrorCode: "",
      buttonCooldown: false,
    };
  },

  mounted() {
    /* Device Lookup */
    let LookUpUrlDevices =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersDevices = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "AllDevices" };
    axios
      .post(LookUpUrlDevices, this.LookUpRequest, LookUpHeadersDevices)
      .then((response) => {
        this.devicelist = response.data.Values;
        for (let i = 0; i < this.devicelist.length; i++) {
          this.deviceArray.push({ id: this.devicelist[i][0] });
        }
      });

    /* Company Lookup */
    let LookUpUrlCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersCompany = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Company" };
    axios
      .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
      .then((response) => {
        this.companylist = response.data.Values;
        for (let i = 0; i < this.companylist.length; i++) {
          var QuoteStr4 = this.companylist[i][0];
          this.companyArray.push({
            id: QuoteStr4,
            name: this.companylist[i][0],
          });
        }
      });

    /* Error Code Look Up */
    let LookUpUrErrorCodes =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersErrorCodes = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "ErrorCode" };

    axios
      .post(LookUpUrErrorCodes, this.LookUpRequest, LookUpHeadersErrorCodes)
      .then((response) => {
        this.DeviceErrorCodesList = response.data.Values;
        for (let i = 0; i < this.DeviceErrorCodesList.length; i++) {
          this.DeviceErrorCodes.push({ id: this.DeviceErrorCodesList[i][0] });
        }
      });

    /* LOCATION LOOKUP */

    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = { RequestType: "Location", RequestVariable: "" };

    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });

    /* DEVICE ERROR Look Up */

    let LookUpURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = { RequestType: "DeviceError", RequestVariable: "" };

    axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
      this.items = "";
      this.testing = response.data.field_names;
      this.items = response.data.Values;
      this.Devices = response.data.Devices;

      for (let i = 0; i < this.items.length; i++) {
        this.ArrTest.push({
          ErrorID: this.items[i][0],
          DeviceID: this.items[i][1],
          Date: this.items[i][2],
          Time: this.items[i][3],
          ErrorCode: this.items[i][4],
          ErrorDetail: this.items[i][5],
        });
      }
      this.items = this.ArrTest;
      this.ArrTest = [];
      this.UserHeaders = this.ArrTest;
    });

    /* AWS ERROR Look Up */

    let LookUpAWSURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpAWSHeaders = this.$apikeyPost;
    let LookUpAWSRequest = { RequestType: "AWSError", RequestVariable: "" };

    axios
      .post(LookUpAWSURL, LookUpAWSRequest, LookUpAWSHeaders)
      .then((response) => {
        this.testing = response.data.field_names;
        this.AWSErrors = response.data.Values;
        this.Devices = response.data.Devices;

        for (let i = 0; i < this.AWSErrors.length; i++) {
          this.ArrTest.push({
            ErrorID: this.AWSErrors[i][0],
            DeviceID: this.AWSErrors[i][1],
            Date: this.AWSErrors[i][2],
            Time: this.AWSErrors[i][3],
            ErrorCode: this.AWSErrors[i][4],
            ErrorDetail: this.AWSErrors[i][5],
          });
        }
        this.AWSErrorsList = this.ArrTest;
        this.ArrTest = [];
        this.UserHeaders = this.ArrTest;
      });

    /* Devices Look Up */

    let LookUpURLDev =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersDev = this.$apikeyPost;
    let LookUpRequestDev = { RequestType: "BMUDevice", UserURN: this.UserURN };

    axios
      .post(LookUpURLDev, LookUpRequestDev, LookUpHeadersDev)
      .then((response) => {
        response;
      });
  },
  methods: {
    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },

    resetInputs() {
      this.AWSFromDate = "";
      this.AWSToDate = "";
      this.AWSErrorCode = "";
      this.AWSLocation = "";
      this.AWSCompany = "";
      this.AWSDeviceID = "";

      this.DeviceFromDate = "";
      this.DeviceToDate = "";
      this.DeviceErrorCode = "";
      this.DeviceLocation = "";
      this.DeviceCompany = "";
      this.DeviceID = "";
    },
    AWSErrorResetFilter() {
      this.resetInputs();
      let LookUpAWSURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpAWSHeaders = this.$apikeyPost;
      let LookUpAWSRequest = { RequestType: "AWSError", RequestVariable: "" };

      axios
        .post(LookUpAWSURL, LookUpAWSRequest, LookUpAWSHeaders)
        .then((response) => {
          this.testing = response.data.field_names;
          this.AWSErrors = response.data.Values;
          this.Devices = response.data.Devices;

          for (let i = 0; i < this.AWSErrors.length; i++) {
            this.ArrTest.push({
              ErrorID: this.AWSErrors[i][0],
              DeviceID: this.AWSErrors[i][1],
              Date: this.AWSErrors[i][2],
              Time: this.AWSErrors[i][3],
              ErrorCode: this.AWSErrors[i][4],
              ErrorDetail: this.AWSErrors[i][5],
            });
          }
          this.AWSErrorsList = this.ArrTest;
          this.ArrTest = [];
          this.UserHeaders = this.ArrTest;
        });
    },

    DeviceErrorResetFilter() {
      this.resetInputs();
      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = { RequestType: "DeviceError", RequestVariable: "" };

      axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
        this.items = "";
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        this.Devices = response.data.Devices;

        for (let i = 0; i < this.items.length; i++) {
          this.ArrTest.push({
            ErrorID: this.items[i][0],
            DeviceID: this.items[i][1],
            Date: this.items[i][2],
            Time: this.items[i][3],
            ErrorCode: this.items[i][4],
            ErrorDetail: this.items[i][5],
          });
        }
        this.items = this.ArrTest;
        this.ArrTest = [];
        this.UserHeaders = this.ArrTest;
      });
    },

    AWSErrorFilter() {
      this.buttonCooldown = true;

      this.AWSFilterType = [];
      if (
        (this.AWSFromDate != "" || this.AWSToDate != "") &
        ((this.AWSFromDate == "") & (this.AWSToDate != "") ||
          (this.AWSFromDate != "") & (this.AWSToDate == "") ||
          this.AWSToDate < this.AWSFromDate)
      ) {
        this.buttonCooldown = false;

        alert("Please ensure date ranges is set correctly");
      } else if (
        (this.AWSFromDate != "") &
        (this.AWSToDate != "") &
        (this.AWSFromDate < this.AWSToDate)
      ) {
        this.buttonCooldown = false;

        this.AWSFilterType.push("Date");
        this.AWSErrorFilterSubmit();
      }
      if (
        (this.AWSFromDate == "") &
        (this.AWSToDate == "") &
        (this.AWSLocation == "") &
        (this.AWSCompany == "") &
        (this.AWSErrorCode == "") &
        (this.AWSDeviceID == "")
      ) {
        this.buttonCooldown = false;

        alert("Please select a filter");
      }
      if (this.AWSErrorCode != "") {
        this.buttonCooldown = false;

        this.AWSFilterType.push("ErrorCode");
        this.AWSErrorFilterSubmit();
      }
      if (this.AWSLocation != "") {
        this.buttonCooldown = false;

        this.AWSFilterType.push("Location");
        this.AWSErrorFilterSubmit();
      }
      if (this.AWSCompany != "") {
        this.buttonCooldown = false;

        this.AWSFilterType.push("Company");
        this.AWSErrorFilterSubmit();
      }
      if (this.AWSDeviceID != "") {
        this.buttonCooldown = false;

        this.AWSFilterType.push("Device");
        this.AWSErrorFilterSubmit();
      }
    },

    AWSErrorFilterSubmit() {
      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "ErrorFilter",
        RequestVariable: "",
        DataDict: [
          {
            FilterType: this.AWSFilterType,
            FromDate: this.AWSFromDate,
            ToDate: this.AWSToDate,
            ErrorType: "AWS",
            Location: this.AWSLocation.id,
            Company: this.AWSCompany.id,
            ErrorCode: this.AWSErrorCode,
            DeviceID: this.AWSDeviceID.id,
          },
        ],
      };
      axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
        this.buttonCooldown = false;

        this.testing = response.data.field_names;
        this.AWSErrors = response.data.Values;
        this.Devices = response.data.Devices;

        for (let i = 0; i < this.AWSErrors.length; i++) {
          this.ArrTest.push({
            ErrorID: this.AWSErrors[i][0],
            DeviceID: this.AWSErrors[i][1],
            Date: this.AWSErrors[i][2],
            Time: this.AWSErrors[i][3],
            ErrorCode: this.AWSErrors[i][4],
            ErrorDetail: this.AWSErrors[i][5],
          });
        }
        this.AWSErrorsList = this.ArrTest;
        this.ArrTest = [];
        this.UserHeaders = this.ArrTest;
      });
    },

    DeviceErrorFilter() {
      this.buttonCooldown = true;

      this.DeviceFilterType = [];

      if (
        (this.DeviceFromDate == "") &
        (this.DeviceToDate == "") &
        (this.DeviceLocation == "") &
        (this.DeviceCompany == "") &
        (this.DeviceErrorCode == "") &
        (this.DeviceID == "")
      ) {
        this.buttonCooldown = false;

        alert("Please Select a Filter");
      }

      if (
        (this.DeviceFromDate != "" || this.DeviceToDate != "") &
        ((this.DeviceFromDate == "") & (this.DeviceToDate != "") ||
          (this.DeviceFromDate != "") & (this.DeviceToDate == "") ||
          this.DeviceToDate < this.DeviceFromDate)
      ) {
        this.buttonCooldown = false;

        alert("Please ensure date ranges is set correctly");
      } else if (
        (this.DeviceFromDate != "") &
        (this.DeviceToDate != "") &
        (this.DeviceFromDate < this.DeviceToDate)
      ) {
        this.buttonCooldown = false;

        this.DeviceFilterType.push("Date");
        this.DeviceErrorFilterSubmit();
      }
      if (this.DeviceErrorCode != "") {
        this.buttonCooldown = false;

        this.DeviceFilterType.push("ErrorCode");
        this.DeviceErrorFilterSubmit();
      }
      if (this.DeviceLocation != "") {
        this.buttonCooldown = false;

        this.DeviceFilterType.push("Location");
        this.DeviceErrorFilterSubmit();
      }
      if (this.DeviceCompany != "") {
        this.buttonCooldown = false;

        this.DeviceFilterType.push("Company");
        this.DeviceErrorFilterSubmit();
      }
      if (this.DeviceID != "") {
        this.buttonCooldown = false;

        this.DeviceFilterType.push("Device");
        this.DeviceErrorFilterSubmit();
      }
    },

    DeviceErrorFilterSubmit() {
      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/sulookups";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        RequestType: "ErrorFilter",
        RequestVariable: "",
        DataDict: [
          {
            FilterType: this.DeviceFilterType,
            FromDate: this.DeviceFromDate,
            ToDate: this.DeviceToDate,
            ErrorType: "Device",
            Location: this.DeviceLocation.id,
            Company: this.DeviceCompany.id,
            ErrorCode: this.DeviceErrorCode.id,
            DeviceID: this.DeviceID.id,
          },
        ],
      };
      axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
        this.buttonCooldown = false;

        this.items = "";
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        this.Devices = response.data.Devices;

        for (let i = 0; i < this.items.length; i++) {
          this.ArrTest.push({
            ErrorID: this.items[i][0],
            DeviceID: this.items[i][1],
            Date: this.items[i][2],
            Time: this.items[i][3],
            ErrorCode: this.items[i][4],
            ErrorDetail: this.items[i][5],
          });
        }
        this.items = this.ArrTest;
        this.ArrTest = [];
        this.UserHeaders = this.ArrTest;
      });
    },

    showActionModal: function(AlarmID, UnitID, Category, AlarmNote) {
      this.AlarmtobeActioned = AlarmID;
      this.UnitAction = UnitID;
      this.AlarmCategory = Category;
      this.Note = AlarmNote;

      this.$refs["AlarmActionModal"].show(
        this.AlarmtobeActioned,
        this.UnitAction,
        this.AlarmCategory,
        this.Note,
        this.EscalationName,
        this.EscalationContact,
        this.EscalationTel,
        this.EstatesName,
        this.EstatesContact,
        this.EstatesTel
      );
    },

    CallAlarmAPI: function() {
      if (this.locations.includes(this.location)) {
        let location = "'" + this.location + "'";
        let url =
          "https://r46t6xqou3.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/resource?Location=";
        let getUrl = url + location;

        axios.get(getUrl, { headers: this.$apikey }).then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
      } else {
        alert("Please select a location from the autocomplete list");
        this.resetValue();
      }
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },

    checkmodal(checkedactions1, selected1, ServiceType1, ServiceAssign1) {
      if (checkedactions1.length < 1) {
        alert("You must select at least one action");
      } else
        this.submitAlarmActions(
          checkedactions1,
          selected1,
          ServiceType1,
          ServiceAssign1
        );
    },

    submitAlarmActions(checkedactions1) {
      /*Post Logic need to go here*/

      if (checkedactions1.includes("Acknowledge")) {
        this.LookUpRequest = {
          Actions: this.checkedactions,
          RequestID: this.AlarmtobeActioned,
          ActionedBy: this.UserURN,
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            this.resetValue();
            alert("Action Submitted");
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (checkedactions1.includes("Complete")) {
        this.LookUpRequest = {
          Actions: this.checkedactions,
          RequestID: this.AlarmtobeActioned,
          ActionedBy: this.UserURN,
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            this.resetValue();
            alert("Action Submitted");
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (checkedactions1.includes("Clear")) {
        this.LookUpRequest = {
          Actions: this.checkedactions,
          RequestID: this.AlarmtobeActioned,
          ActionedBy: this.UserURN,
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            this.resetValue();
            alert("Action Submitted");
          })
          .catch((err) => {
            "Error: ===", err;
          });
      }

      this.checkedactions = [];
      this.selected = "";
      this.ServiceAssign = "";
      this.ServiceType = "";
      (this.selectedEstates = ""),
        (this.selectedEscalation = ""),
        this.$refs["AlarmActionModal"].hide();
    },

    resetAlarmActions() {
      this.ServiceAssign = "";
      this.ServiceType = "";
      this.checkedactions = [];
      (this.selectedEstates = ""), (this.selectedEscalation = "");
    },
    locationLookUp() {
      if (
        (this.SearchCategory == "") &
        (this.locationSearch == "") &
        (this.SearchAlert == "") &
        (this.deviceSearch == "")
      ) {
        alert("Please select a search category");
      }
      if ((this.locationSearch != "") & (this.deviceSearch != "")) {
        alert(
          "You cannot search location and device together. Please only select one of these filters at a time"
        );
        this.resetValue();
      } else if (
        (this.deviceSearch != "") &
        (this.SearchCategory != "") &
        (this.SearchAlert != "")
      ) {
        this.FilterType = "DeviceLevelCategory";
        this.FilterSubmit();
      } else if (
        (this.locationSearch != "") &
        (this.SearchCategory != "") &
        (this.SearchAlert != "")
      ) {
        this.FilterType = "LocationLevelCategory";
        this.FilterSubmit();
      } else if ((this.deviceSearch != "") & (this.SearchCategory != "")) {
        this.FilterType = "CategoryDevice";
        this.FilterSubmit();
      } else if ((this.deviceSearch != "") & (this.SearchAlert != "")) {
        this.FilterType = "LevelDevice";
        this.FilterSubmit();
      } else if ((this.locationSearch != "") & (this.SearchCategory != "")) {
        this.FilterType = "LocationCategory";
        this.FilterSubmit();
      } else if ((this.locationSearch != "") & (this.SearchAlert != "")) {
        this.FilterType = "LocationLevel";
        this.FilterSubmit();
      } else if ((this.SearchAlert != "") & (this.SearchCategory != "")) {
        this.FilterType = "LevelCategory";
        this.FilterSubmit();
      } else if (this.deviceSearch != "") {
        this.FilterType = "Device";
        this.FilterSubmit();
      } else if (this.locationSearch != "") {
        this.FilterType = "Location";
        this.FilterSubmit();
      } else if (this.SearchCategory != "") {
        this.FilterType = "Category";
        this.FilterSubmit();
      } else if (this.SearchAlert != "") {
        this.FilterType = "Level";
        this.FilterSubmit();
      }
      /*
      else if(this.SearchCategory !="" & this.locationSearch !="" & this.SearchAlert ==""){
        this.FilterType = "LocationCategory"
        this.FilterSubmit()

    } */
    },
  },
  watch: {
    location() {
      this.filterLocations();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
}
.form-control {
  width: 100%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
}

table[data-v-510a9cc0] {
  font-size: small;
  color: black;
}

.Auto {
  padding-left: 15px;
}

h4 {
  color: #585858;
}
.Red {
  background-color: red;
  color: white;
}
.Amber {
  background-color: orange;
  color: white;
}
#CentreDiv {
  text-align: center;
  padding-bottom: 30px;
  padding-top: 20px;
  border-bottom: solid 2px rgb(220, 220, 220);

  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 3rem;
  margin-right: 3rem;
}

.SearchRow {
  padding-bottom: 15px;
}

input[type="text"],
select {
  width: 100%;

  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 15px;

  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.row {
  border-style: none;
}

ul {
  float: left;
  margin: 0;
  padding: 0;
}

li {
  float: left;
}
#unitByStatus {
  margin-top: 10px;
}

table {
  color: black;
}
h4 {
  color: black;
}

h5 {
  font-size: 1rem;
}

.tablinksActive {
  width: 25%;
}

div.tab {
  padding: 0;
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 50%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 20%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 50%;
}

.reportTabActive {
  width: 50%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}

.tabcontent {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  height: auto;
}
</style>
